var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { MenuPartTopicTitle } from './menu/Abfrager_1_MenuPartTopicTitle';
import { MenuPartSubTopicTitle } from './menu/Abfrager_2_MenuPartSubTopicTitle';
import { CycleDots_ } from '../../../../areas/CycleBar/Dot/CycleDots_';
import { MenuPartGrade } from './menu/Abfrager_4_MenuPartGrade';
import { MenuPartDifficulty } from './menu/Abfrager_5_MenuPartDifficulty';
import { MenuPartRating } from './menu/Abfrager_6_MenuPartRating';
let AbfragerQuestionMenuPart = class AbfragerQuestionMenuPart extends React.PureComponent {
    render() {
        const { question } = this.props;
        const topic = question.context.solidTopic;
        // data-aspect="ShowQuestionMenuPart"
        return (React.createElement("div", { className: "ShowQuestionMenuPart", style: { flex: '1 1 auto', display: 'flex', flexDirection: 'column', minWidth: 190 } },
            React.createElement(MenuPartTopicTitle, { topic: topic }),
            React.createElement(MenuPartSubTopicTitle, { question: question }),
            React.createElement("div", { style: {
                    height: 15,
                    display: 'flex',
                    alignItems: 'stretch',
                    marginRight: 20,
                    marginLeft: 10,
                    marginTop: 10
                } },
                React.createElement(CycleDots_, { app: question.context.app })),
            React.createElement(MenuPartGrade, { app: question.context.app }),
            React.createElement(MenuPartDifficulty, { question: question }),
            React.createElement(MenuPartRating, { question: question })));
    }
};
AbfragerQuestionMenuPart = __decorate([
    observer
], AbfragerQuestionMenuPart);
export { AbfragerQuestionMenuPart };
